import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ArgoApp } from '@amzn/awsscm-argo-core';
import { rumPaths } from 'resources/urls';

import App from './App';
import * as serviceWorker from './serviceWorker';

import '@amzn/awsui-global-styles/polaris.css';
import '@amzn/awsscmui-argo-chatbot-component/argo/index.css';
import 'ag-grid-community/styles//ag-grid.css';
import 'ag-grid-community/styles//ag-theme-alpine.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <div className="awsui">
    <React.StrictMode>
      {
        // A BrowserRouter allows us to render and navigate between different pages
        // See https://reacttraining.com/react-router/web/guides/quick-start for more info
        // Setting the basename prop allows this page to be rendered from that base path.
        // This value should match the path on the homepage attribute in your package.json.
      }
      <BrowserRouter basename={'/smart'}>
        <ArgoApp content={<App />} urls={Object.values(rumPaths)}/>
      </BrowserRouter>
    </React.StrictMode>
  </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
